import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

// vendor
import { ModalModule } from 'angular2-modal';
import { BootstrapModalModule } from 'angular2-modal/plugins/bootstrap';
import { MomentModule } from 'angular2-moment';

// shared components
import { ChosenDropdownComponent } from '../components/shared/chosen-dropdown/chosen-dropdown.component';
import { HjIntlTelInputComponent } from './components/hj-intl-tel-input/hj-intl-tel-input.component';

// pipes
import { ObjToArrayPipe } from '../pipes/object-to-array.pipe';
import { ObjKeysPipe } from '../pipes/object-keys.pipe';
import { RoundNumberPipe } from '../pipes/round-number.pipe';
import { TimezoneOffsetPipe } from '../pipes/timezone-offset.pipe';

// directives
import { MinValueValidatorDirective } from '../directives/min-value-validator.directive';
import { TooltipComponent } from './components/tooltip/tooltip.component';
import { TooltipContainerDirective } from './components/tooltip/tooltip-container.directive';
import { TooltipDirective } from './components/tooltip/tooltip.directive';


export class SharedModule { }



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/shared/shared.module.ts